<span class="p-2">{{
  countdown | countDown: isStarted : isFinished : getAuctionStatus
}}</span>
